export default __webpack_public_path__ + "static/media/image-1.70f63826.jpg";